var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tenant-provider-manager uk-list"
  }, _vm._l((_vm.providerStatuses), function(providerStatus, index) {
    return _c('li', {
      key: index,
      staticClass: "tenant-provider-manager__entry"
    }, [_c('checkbox', {
      attrs: {
        "disabled": _vm.isSubmitting,
        "label": _vm.getProviderName(providerStatus.provider),
        "value": providerStatus.enabled
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          _vm.maybeToggleProvider(index)
        }
      }
    })], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34dba387","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/TenantProviderManager.vue
// module id = 1925
// module chunks = 0